import React from 'react';
import './LoadingScreen.css';

export default function LoadingScreen({ fadeOut }) {
    return (
        <div className={`loading-screen${fadeOut ? ' fade-out' : ''}`}>
            <div className="loading-content">
                <p className="loading-lab-name">Bendall Laboratory</p>
                <div className="loading-bar">
                    <div className="loading-bar-fill" />
                </div>
            </div>
        </div>
    );
}
